import React, { useMemo } from 'react'

import { DealNode } from '@/apollo/graphql'
import { AboutNode } from '@/components'
import FileListButton from '@/components/buttons/FileListButton'
import FileUploadButton from '@/components/buttons/FileUploadButton'
import { useApp } from '@/hooks'
import { t } from '@/i18n'
import { useBuildData } from '@/pages/Deals/utils'
import useIsMobile from '@/hooks/useIsMobile'

const colors = ['#36af69', '#36af69', '#ff4a44', '#ff9c41']
const statuses = ['OPEN', 'CLOSED', 'CANCELED', 'RENT']

const DealsInfo: React.FC<{
  onClose?: () => void
  loading?: boolean
  node?: Partial<DealNode>
  onEdit: (bool: boolean) => void
  onHistory: (bool: boolean) => void
}> = ({ node, onClose, onEdit, onHistory, loading = false }) => {
  const { isRTL } = useApp()
  
  const isMobile = useIsMobile()
  
  const color = colors[statuses.indexOf(node?.status || '')]

  const buildData = useBuildData(node as any, color)

  const details = useMemo(
    () => (node ? buildData : { general_info: [], financial_details: [] }),
    [buildData],
  )

  return (
    <AboutNode
      loading={loading}
      sections={[
        {
          title: 'general_info',
          data: node ? details.general_info : [],
          headerButtons: [
            {
              children: (
                <>
                  <span className="icon-edit"></span>
                  {t('edit')}
                </>
              ),
              className: 'main-btn outline',
              onClick: () => onEdit(true),
            },
            {
              children: (
                <>
                  <span className="icon-history"></span>
                  {t('history')}
                </>
              ),
              className: 'main-btn green',
              onClick: () => onHistory(true),
            },
            {
              component: FileListButton,
              props: {
                contextType: 'deal',
                contextId: node?.id || '',
              },
            },
            !isMobile && {
              component: FileUploadButton,
              props: {
                contextType: 'deal',
                contextId: node?.id || '',
              },
            },
          ],
        },
        {
          title: 'financial_details',
          data: node ? details.financial_details : [],
        },
      ]}
      node={node}
      onClose={() => onClose?.()}
    />
  )
}

export default DealsInfo
